<template>
  <v-card
    class="rounded-0 b-blog-content transparent user-select-none"
    flat
    width="100%"
    :style="{
      color: bstyle?.color || 'inherit',
    }"
  >
    <v-card-title
      v-if="hasGallery"
      :href="
        !!data.gallery[0].images[0].link
          ? fixLink(data.gallery[0].images[0].link)
          : ''
      "
      :tag="!!data.gallery[0].images[0].link ? 'a' : 'div'"
      target="_blank"
    >
      <img :src="data.gallery[0].images[0].url" width="100%" alt="" />
    </v-card-title>

    <v-card-title v-else-if="data.color">
      <div :style="{ background: data.color }" class="b-color" />
    </v-card-title>

    <v-card-title v-else-if="data.icon" class="justify-center flex-column">
      <v-icon color="black" size="85">{{ data.icon }}</v-icon>
    </v-card-title>

    <v-card-title class="font-size-h5 text-break py-0">
      <pre
        :class="
          isTruncate ? 'dark-text text-right my-0' : 'dark-text text-right my-0'
        "
        style="white-space: pre-line"
        :style="{
          color: bstyle?.text || 'inherit',
        }"
        v-html="trancateTxts"
      ></pre>
    </v-card-title>

    <v-card-actions>
      <v-btn
        v-if="
          (data.content && data.content.length > 200) ||
          data.content.split('<div>').length > 3
        "
        class="ms-n4"
        color="primary"
        text
        @click="isTruncate = !isTruncate"
      >
        {{ isTruncate ? "ادامه مطلب" : "مشاهده کمتر" }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "bBlogCard",

  props: {
    data: Object,
    bstyle: Object,
  },
  data() {
    return {
      isTruncate: false,
    };
  },

  computed: {
    trancateTxts() {
      let about = this.data?.content;

      const more = about?.split("<div>").length > 3;

      const text = () => {
        let variable = about?.split("<div>");
        let generatedText = "";
        for (let a = 0; a <= 3; a++) {
          generatedText += "<div>" + variable[a];
        }
        return generatedText;
      };

      about =
        (about?.length > 200 || more) && this.isTruncate
          ? (more ? text() : about?.slice(0, 100)) + "&hellip;"
          : about;

      return about
        .replace(
          /style="width:604px;height:270px" /gms,
          'style="width:100%;height:auto"'
        )
        .replace(/style="display: block;padding-top: 57%"/gms, "");
      // return about.replace(/<div class="h_iframe-.*<iframe/gms, '<iframe ').replace(/ style="width:604px;height:270px" /gms, '');
    },
    hasGallery() {
      return !!this.data.gallery?.filter((item) => !!item.images?.length)
        ?.length;
    },
  },

  watch: {
    data: {
      deep: true,

      handler(val) {
        this.$forceUpdate();
      },
    },
  },
};
</script>

<style scoped>
pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
}

.b-blog-content >>> .v-image .v-image__image {
  transition: transform 0.3s ease-out;
}

.b-blog-content:hover >>> .v-image .v-image__image {
  transform: scale(1.1);
  filter: grayscale(30%);
}

.b-color {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 150px;
  height: 100%;
  width: 100%;
  transition: all 0.3s ease-out;
  background-size: cover !important;
  background-position: center !important;
}
</style>
